module.exports = __webpack_public_path__ + "img/70.ea1fc3f7.png";